<template>
  <!-- .more-->
  <div class="more">
    <div class="nav-tab">
      <div class="van-tabs__wrap">
        <van-sticky offset-top="42">
          <div class="my van-tabs__nav van-tabs__nav--line" style="padding-bottom: 0; border-bottom: 1px solid #f2f2f2;height: 44px;">
            <div role="tab" class="van-tab" v-for="(item, index) in tabType" :key="index" @click="selectTab(index)" :class="activeIndex == index ? 'tab-active' : ''">
              <span class="van-tab__text">{{ item }}</span>
            </div>
            <div class="nav-left"></div>
          </div>
        </van-sticky>
        <actList ref="actList" v-if="activeIndex === 0"></actList>
        <actList2 ref="actList2" v-if="activeIndex === 1"></actList2>
      </div>
    </div>
  </div>
</template>

<script>
import actList from "./act-list";
import actList2 from "./act-list2";
import { mapActions } from "vuex";
export default {
  name: "more",
  data() {
    return {
      tabType: ["All", "Preparing"],
      activeIndex: 0,
    };
  },
  components: {
    actList,
    actList2,
  },
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
    }),
    selectTab(index) {
      this.$Myapollo.addExhibitionView();
      this.activeIndex = index;
    },
    reset() {
      if (this.$refs["actList"]) {
        this.$refs["actList"].reset();
      }
      if (this.$refs["actList2"]) {
        this.$refs["actList2"].reset();
      }
      this.activeIndex = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.more {
  background-color: #fff;
  padding-top: 10px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1) inset;
  .nav-left {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    width: 60%;
    display: flex;
    align-items: center;
  }
  .tab-active {
    color: #ff5c00;
    position: relative;
  }
  .tab-active::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 34px;
    height: 2px;
    background-color: #ff5c00;
    border-radius: 1px;
  }
  .nav-tab {
    min-height: calc(100vh - 0.93rem - 0.93rem);
  }
}
.f-tac {
  text-align: center;
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.my {
  padding-bottom: 0;
  border-bottom: 1px solid #f2f2f2;
  .tab-active {
    position: relative;
    color: #1890ff;
  }
  .tab-active::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 34px;
    height: 2px;
    background: #1890ff;
    border-radius: 1px;
  }
  .nav-tab {
    min-height: calc(100vh - 0.93rem - 0.93rem);
  }
}
</style>